//请自行添加语言资源
const box = {
  creator:'创建者',
  recycleBoxNo:'周转箱号',
  recycleBoxNoBegin: '周转箱号起始',
  recycleBoxNoEnd: '周转箱号结束',
  createTime:'创建时间',
  warehouseCode:'仓库',
  activeOff:'是否有效',
  updater:'失效人',
  updateTime:'失效时间',
  warehouseName: '仓库',
  msg:{
    recycleBoxNo: '请输入周转箱号起始数字',
    recycleBoxNoBegin: '请输入周转箱号结束数字',
    recycleBoxNoEnd: '请输入周转箱号',
    warehouseCode: '请选择仓库'
  }
};
export default box



// WEBPACK FOOTER //
// ./src/page/md/box/lang/mdBox.zh.js